import { createContext } from 'react';
export var defaultPrimaryDimensionDirection = 'vertical';
export var primaryDimensionDirectionContext = createContext(defaultPrimaryDimensionDirection);
